import { spacing } from "@/utils/spacing";
import { ChatSuggestionOpt } from "../types";
import ChatSuggestionOption from "./styled/ChatSuggestionOption";
import { childrenAsKey } from "@/utils/childrenAsKey";
import ChatSuggestionAnimation from "./styled/ChatSuggestionAnimation";

export const ChatSuggestionsBasic = ({ options, disabled }: { options?: ChatSuggestionOpt[]; disabled?: boolean }) => {
    return (
        <ChatSuggestionAnimation in={!disabled} style={{ display: "flex", flexDirection: "column", gap: spacing.XS_2 }}>
            {options?.map(({ id, label, icon, disabled, onClick, style }, i) => {
                return (
                    <ChatSuggestionOption
                        key={childrenAsKey({ children: label, seed: i })}
                        id={id}
                        disabled={disabled}
                        onClick={typeof onClick === "function" ? onClick : undefined}
                        style={style}>
                        {icon}
                        {label}
                    </ChatSuggestionOption>
                );
            })}
        </ChatSuggestionAnimation>
    );
};

export const ChatSuggestionsOnSelected = ({
    options,
    disabled,
    style,
}: {
    options?: ChatSuggestionOpt[];
    disabled?: boolean;
    style?: React.CSSProperties;
}) => {
    return (
        <ChatSuggestionAnimation
            in={!disabled}
            style={{ display: "grid", gridTemplateColumns: `repeat(2, 1fr)`, gap: spacing.XS, ...style }}>
            {options?.map(({ id, label, icon, onClick, disabled: isOptionDisabled, style }, i) => (
                <ChatSuggestionOption
                    key={childrenAsKey({ children: label, seed: i })}
                    id={id}
                    disabled={disabled || isOptionDisabled}
                    onClick={typeof onClick === "function" ? onClick : undefined}
                    style={style}>
                    {icon}
                    {label}
                </ChatSuggestionOption>
            ))}
        </ChatSuggestionAnimation>
    );
};

export const ChatSuggestionsUponAnswerGenerated = ({
    options,
    disabled,
}: {
    options?: ChatSuggestionOpt[];
    disabled?: boolean;
}) => {
    return (
        <ChatSuggestionAnimation
            in={!disabled}
            style={{ display: "grid", gridTemplateColumns: `repeat(2, 1fr)`, gap: spacing.XS }}>
            {options?.map(({ id, label, icon, onClick, disabled: isOptionDisabled, style }, i) => (
                <ChatSuggestionOption
                    key={childrenAsKey({ children: label, seed: i })}
                    id={id}
                    disabled={disabled || isOptionDisabled}
                    onClick={typeof onClick === "function" ? onClick : undefined}
                    style={style}>
                    {icon}
                    {label}
                </ChatSuggestionOption>
            ))}
        </ChatSuggestionAnimation>
    );
};
